import React, {Component} from 'react';
import {Line} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getGradients} from './budget_charts_util';

class TimeChart extends Component {
	getChartData() {
		const {itemsOutsideProjectPeriod, isEstimatedInNewPoints} = this.props;
		const {formatMessage} = this.props.intl;
		const {registeredMinutesPerDay, plannedMinutesPerDay, project, labels} = this.props.data;
		const {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual} = getGradients();

		const datasets = [];
		if (!isEstimatedInNewPoints) {
			datasets.push({
				label: formatMessage({id: 'project_budget.planned_time'}),
				borderColor: gradientStroke,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: 'rgba(217, 248, 232, 0.2)',
				pointHoverBorderColor: '#fff',
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFill,
				borderWidth: 2,
				data: getAccumulation(getChartDataByDay({project, dayData: plannedMinutesPerDay})),
			});
		}
		datasets.push({
			label: formatMessage({id: 'project_budget.actual_time'}),
			borderColor: gradientStrokeActual,
			pointBackgroundColor: 'rgb(234, 248, 255)',
			pointHoverBorderColor: '#fff',
			pointHoverRadius: 0,
			pointHoverBorderWidth: 2,
			pointRadius: 0,
			fill: true,
			backgroundColor: gradientFillActual,
			borderWidth: 2,
			data: getAccumulation(getChartDataByDay({project, dayData: registeredMinutesPerDay})),
		});
		if (itemsOutsideProjectPeriod) datasets.push(itemsOutsideProjectPeriod);

		return {datasets, labels};
	}

	render() {
		return <Line data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(TimeChart);
